import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  ReadingRoomSubmissionCommunicationDto,
  ReadingRoomSubmissionCommunicationListItemDto,
  BackofficeReadingRoomSubmissionCard
} from 'types/service.interface';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { ApiService } from 'services/api.service';
import { AddAppClientNoteModalComponent } from 'components/modal/add-app-client-note-modal/add-app-client-note-modal.component';
import { formatDatetime } from 'util/date.utility';
import { RequestAdditionalInfoModalComponent } from 'components/modal/request-additional-info-modal/request-additional-info-modal.component';
import { MAX_LENGTH_NAME } from 'util/form.utility';
import { BackofficeStatus } from 'types/visit-room.interface';
import { FileUploadComponent } from 'components/file-upload/file-upload.component';
import { FILE_OBJECT_TYPE_COMMUNICATION_BACKOFFICE, FILE_OBJECT_TYPE_COMMUNICATION_FRONTOFFICE } from 'types/file.interface';
@Component({
  selector: 'app-application-conversation',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    TooltipComponent,
    AddAppClientNoteModalComponent,
    RequestAdditionalInfoModalComponent,
    FileUploadComponent
  ],
  templateUrl: './application-conversation.component.html',
  styleUrls: ['./application-conversation.component.scss', '../../form/base-form.scss']
})
export class ApplicationConversationComponent implements OnInit, OnChanges {
  public readonly maxFieldLength = MAX_LENGTH_NAME;
  public readonly formatDatetime = formatDatetime;
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Input() conversationList!: ReadingRoomSubmissionCommunicationListItemDto[];
  @Output() markedAsRead: EventEmitter<void> = new EventEmitter();
  @Output() messageSaved: EventEmitter<ReadingRoomSubmissionCommunicationListItemDto | ReadingRoomSubmissionCommunicationDto> =
    new EventEmitter();
  isAddClientNoteModalOpen: boolean = false;
  isRequestAdditionalInfoModalOpen: boolean = false;
  isEditClientNoteModalOpen: boolean = false;
  backofficeStatus!: BackofficeStatus;
  editNote: ReadingRoomSubmissionCommunicationListItemDto | ReadingRoomSubmissionCommunicationDto | null = null;
  public readonly communicationFileTypeFrontoffice = FILE_OBJECT_TYPE_COMMUNICATION_FRONTOFFICE;
  public readonly communicationFileTypeBackoffice = FILE_OBJECT_TYPE_COMMUNICATION_BACKOFFICE;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    const status = this.application.backofficeStatus;
    this.backofficeStatus = Object.values(BackofficeStatus).includes(status as BackofficeStatus)
      ? (status as BackofficeStatus)
      : BackofficeStatus.Unknown;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['application']) {
      this.application = changes['application'].currentValue;

      const status = this.application.backofficeStatus;
      this.backofficeStatus = Object.values(BackofficeStatus).includes(status as BackofficeStatus)
        ? (status as BackofficeStatus)
        : BackofficeStatus.Unknown;
    }
  }

  get shouldRenderRequestAdditionalInfoButton(): boolean {
    const allowedStatuses = [
      BackofficeStatus.InProcess,
      BackofficeStatus.RequestedAdditionalInformation,
      BackofficeStatus.SubmittedAdditionalInformation,
      BackofficeStatus.Approved
    ];
    return allowedStatuses.includes(this.backofficeStatus);
  }

  requestAdditionalInfo(): void {
    this.isRequestAdditionalInfoModalOpen = true;
  }

  addClientNote(): void {
    this.isAddClientNoteModalOpen = true;
  }

  onMessageSaved(message: ReadingRoomSubmissionCommunicationListItemDto | ReadingRoomSubmissionCommunicationDto): void {
    this.messageSaved.emit(message);
  }

  markAsRead(id: string): void {
    this.apiService.markAsReadAppCommunication(id).subscribe(() => {
      this.conversationList = this.conversationList.map((item) => {
        if (item.id === id && item.frontofficeText) {
          item.isReadByBackoffice = true;
        }

        this.markedAsRead.emit();
        return item;
      });
    });
  }

  editMessage(message: ReadingRoomSubmissionCommunicationListItemDto): void {
    this.editNote = message;
    this.isEditClientNoteModalOpen = true;
  }
}
